import React, { useCallback, useState } from 'react';
import Layout from '../Components/Layout/Layout';
import { Link } from 'react-router-dom';
import ArrowBrad from "../Components/Images/bradcumb-ico.svg";
import EyeOpenIco from "../Components/Images/eye.svg";
import EyeCloseIco from "../Components/Images/eye-slash.svg";
import { useForm } from 'react-hook-form';
import { PostApiWithoutLogin } from '../apiService';
import { API_PATH } from '../const';
import { toast } from 'react-toastify';

export default function AddLocation() {
    const { 
        register, 
        handleSubmit, 
        getValues,
        reset,
        formState: { errors }, 
    } = useForm(); 
    
    const onSubmit = useCallback(() => {
        const data = getValues();

        const SumbitInquiryForm = Promise.resolve(PostApiWithoutLogin(API_PATH.NewLocation, data));
        SumbitInquiryForm.then(response => {
            if(response.status === 200){
                toast.success("New Location Added!");
                reset();
            } else toast.error(response.response.data?.message ?? "Could not add new location.");
        })
    }, [getValues]);

    return (
        <Layout>
            <div className="nav-top-section">
                <div className="container-fluid ">
                    <div className="row">
                        <div className="col-12">
                            <div className="bradcumb-text d-flex">
                                <Link to="/locations">Locations</Link>
                                <img src={ArrowBrad} loading="lazy" alt="" />
                                <span>Add/Modify New Location</span>
                            </div>
                            <div className="bx-white-main">
                                <h2>Add/Modify New Location</h2>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="row me-0">
                                        <div className="col-md-6 pe-0 mb-2 pb-1">
                                            <label className="lbl-info-common">
                                                Locality*
                                            </label>
                                            <input type="text" 
                                            className="form-control form-style-input" 
                                            placeholder="" name="" 
                                            {...register("LocalityName", { required: "Please Enter Locality Name" })}
                                            />
                                        
                                        </div>
                                        <div className="col-md-6 pe-0 mb-2 pb-1">
                                            <label className="lbl-info-common">
                                                City*
                                            </label>
                                            <input type="text" 
                                            className="form-control form-style-input" 
                                            placeholder="" name="" 
                                            {...register("City", { required: "Please Enter City" })} 
                                            />
                                        </div>
                                        <div className="col-md-6 pe-0 mb-2 pb-1">
                                            <label className="lbl-info-common">
                                                District*
                                            </label>
                                            <input type="text" 
                                            className="form-control form-style-input" 
                                            placeholder="" 
                                            name="" {...register("District", { required: "Please Enter District" })} 
                                            />
                                        </div>
                                        <div className="col-md-6 pe-0 mb-2 pb-1">
                                            <label className="lbl-info-common">
                                                State*
                                            </label>
                                            <input type="text" 
                                            className="form-control form-style-input" 
                                            placeholder="" name="" 
                                            {...register("State", { required: "Please Enter State" })}
                                            />
                                        </div>
                                        <div className="col-md-6 pe-0 mb-2 pb-1">
                                            <label className="lbl-info-common">
                                                Pincode*
                                            </label>
                                            <input type="number" 
                                            className="form-control form-style-input" 
                                            placeholder="" name="" 
                                            {...register("Pincode", { required: "Please Enter Pincode" })}
                                            />
                                        </div>
                                    </div>
                                    <div className="pt-2 text-md-end text-center frm-btn-btm"> 
                                        <Link to="/locations" className="btn-all-cancel" type="button">
                                            Cancel
                                        </Link>
                                        <button className="btn-all-comn" type="submit">
                                            Add Location
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}